import { render, staticRenderFns } from "./Asset-Preview-Card.vue?vue&type=template&id=6b4959bb&lang=pug"
import script from "./Asset-Preview-Card.vue?vue&type=script&setup=true&lang=ts"
export * from "./Asset-Preview-Card.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports